var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"pa-5",staticStyle:{"max-width":"800px"},attrs:{"id":"reports"}},[_c('h1',{staticClass:"text-h5 font-weight-medium mb-5"},[_vm._v("Support Request Form")]),_c('support-request-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }